module.exports = __webpack_public_path__ + "images/花筑村全景_06-2.jpg?v=a17c2ce2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_06-2.jpg
 ** module id = 94
 ** module chunks = 1 2
 **/